import { BvTableFieldArray } from 'bootstrap-vue';

export const faultsTableFields: BvTableFieldArray = [
	{ key: 'name', label: 'Name' },
	{ key: 'status', sortable: true, label: 'Status' },
	{ key: 'ownerType', label: 'Fault On', sortable: true },
	{ key: 'owner', label: 'Name', sortable: true },
	{ key: 'productId', label: 'Product Id' },
	{ key: 'createdAt', sortable: true, label: 'Created' },
	{ key: 'updatedAt', sortable: true, label: 'Updated' },
];
